export default "__VITE_ASSET__S_mkgfBw__"